import { render, staticRenderFns } from "./BulkTreatmentImportForm.vue?vue&type=template&id=4523a3da"
import script from "./BulkTreatmentImportForm.vue?vue&type=script&lang=js"
export * from "./BulkTreatmentImportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports